//import AppSidebar from "@/layouts/App/NavDrawer";
import AppToolbar from "@/layouts/App/Toolbar";
//import AppToolbarMinima from "@/layouts/App/ToolbarMinima";
import AppToolbarMinimaAzul from "@/layouts/App/ToolbarMinimaAzul";
import AppFooter from "@/layouts/App/Footer";
import AppFooterCmc from "@/layouts/App/FooterCMC";

import LegalPage from "@/views/LegalPage";
import HomePage from "@/views/HomePage";
import SignaturePage from "@/views/SignaturePage";
import CertifiedNotificationPage from "@/views/CertifiedNotificationPage";
import CreateSignPage from "@/views/CreateSignPage";
import PricingPage from "@/views/PricingPage";
import ApiPage from "@/views/ApiPage";
import RegisterPage from "@/views/RegisterPage";
import LoginPage from "@/views/LoginPage";
import ForgotPassword from "@/views/ForgotPassword";
import ProfilePage from "@/views/ProfilePage";
import IdentificationPage from "@/views/IdentificationPage";
import FeaturesPage from "@/views/FeaturesPage";
import FullPage from "@/layouts/App/Toolbar";
import SimpleSignature from "@/views/SimpleSignature";
import HandWrittenSignature from "@/views/HandWrittenSignature";
import IdentificationSignature from "@/views/IdentificationSignature";
import ResumeIdentification from "@/views/ResumeIdentification";
import ResumeSignature from "@/views/ResumeSignature";
import ToolbarSignature from "@/components/signature/ToolbarSignature";
import PaymentPage from "@/views/PaymentPage";
import PayPalPaymentPage from "@/views/PayPalPaymentPage";
import PrePayPalPaymentPage from "@/views/PrePayPalPaymentPage";
import ProductsPage from "@/views/ProductsPage";
import ContactPage from "@/views/ContactPage";
import ContactListPage from "@/views/ContactListPage";

export const routes = [
  { path: "/", redirect: "/contactpage", name: "ContactPage" },
  {
    path: "/legal",
    name: "legalInformation",
    components: {
      default: LegalPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/contactpage",
    name: "ContactPage",
    components: {
      default: ContactPage,
      header: AppToolbarMinimaAzul,
      footer: AppFooterCmc
    }
  },  
  {
    path: "/contactlistpage",
    name: "ContactListPage",
    components: {
      default: ContactListPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },  
  {
    path: "/fullpage",
    name: "FullPage",
    components: {
      default: FullPage,
      footer: AppFooter
    }
  },
  {
    path: "/homepage",
    name: "HomePage",
    components: {
      default: HomePage,
      header: AppToolbar,
      footer: AppFooter
    }
  },

  {
    path: "/signaturepage",
    name: "SignaturePage",
    components: {
      default: SignaturePage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    components: {
      default: ForgotPassword,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/notificationpage",
    name: "NotificationPage",
    components: {
      default: CertifiedNotificationPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/identificationpage",
    name: "IdentificationPage",
    components: {
      default: IdentificationPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },

  {
    path: "/createsignpage",
    name: "CreateSignPage",
    components: {
      default: CreateSignPage,
      header: AppToolbarMinimaAzul,
      footer: AppFooterCmc
    },
  props: (route) => ({ query: route.query.lang }) 

  },
  {
    path: "/pricingpage",
    name: "PricingPage",
    components: {
      default: PricingPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/apipage",
    name: "ApiPage",
    components: {
      default: ApiPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/featurespage",
    name: "FeaturesPage",
    components: {
      default: FeaturesPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/registerpage",
    name: "RegisterPage",
    components: {
      default: RegisterPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/loginpage",
    name: "LoginPage",
    components: {
      default: LoginPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/profilepage",
    name: "ProfilePage",
    components: {
      default: ProfilePage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/products",
    name: "ProductsPage",
    components: {
      default: ProductsPage,
      header: AppToolbar,
      footer: AppFooter
    }
  },
  {
    path: "/simpleSignature",
    name: "simpleSignature",
    components: {
      default: SimpleSignature,
      header: ToolbarSignature,
      footer: AppFooter
    }
  },
  {
    path: "/handwrittenSignature",
    name: "handwrittenSignature",
    components: {
      default: HandWrittenSignature,
      header: ToolbarSignature,
      footer: AppFooter
    }
  },
  {
    path: "/identificationSignature",
    name: "identificationSignature",
    components: {
      default: IdentificationSignature,
      header: ToolbarSignature,
      footer: AppFooter
    },
    props: true
  },
  {
    path: "/resumeIdentification",
    name: "resumeIdentification",
    components: {
      default: ResumeIdentification,
      header: ToolbarSignature,
      footer: AppFooter
    },
    props: true
  },
  {
    path: "/resumeSignature",
    name: "resumeSignature",
    components: {
      default: ResumeSignature,
      header: ToolbarSignature,
      footer: AppFooter
    }
  },
  {
    path: "/paymentPage",
    name: "PaymentPage",
    components: {
      default: PaymentPage,
      header: ToolbarSignature,
      footer: AppFooter
    }
  },
  {
    path: "/paypalPaymentPage",
    name: "PayPalPaymentPage",
    components: {
      default: PayPalPaymentPage,
      header: ToolbarSignature,
      footer: AppFooter
    }
  },
  {
    path: "/prepaypalPaymentPage",
    name: "PrePayPalPaymentPage",
    components: {
      default: PrePayPalPaymentPage,
      header: ToolbarSignature,
      footer: AppFooter
    }
  }
];
